export default function ({ redirect, $axios }) {
  $axios.onError(function (error) {
    if (error.response && error.response.status === 401) {
      return redirect({ name: 'login' })
    }
  })
}
